module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/theme-280.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/theme.md
// module id = 727
// module chunks = 396